<template>
  <div class="grid p-fluid animate__animated animate__fadeIn">
    <div class="col-12">
      <Toast position="top-right" />
      <div class="card card-w-title">
        <h5 class="mb-0">تراکنش ها</h5>
        <Divider type="dashed" />
        <div class="card grid shadow-2 mt-3 p-0">
          <div class="field col-12 md:col-3">
            <InputNumber v-model="ReserveId" dir="rtl" placeholder="شماره رزرو" mode="decimal" :useGrouping="false" />
          </div>
          <div class="field col-12 md:col-3">
            <InputNumber v-model="UserId" dir="rtl" placeholder="آی دی کاربر" mode="decimal" :useGrouping="false" />
          </div>
          <!-- <div class="field col-12 md:col-3">
                        <InputNumber v-model="PlaceId" @keyup.enter="getListTransactions(pageIndex)" dir="rtl" placeholder="آی دی مکان" mode="decimal" :useGrouping="false"/>
                    </div> -->
          <div v-if="!!places.length" class="col-12 md:col-3">
            <MultiSelect v-model="PlacesId" :options="places" optionLabel="name" optionValue="id" :showToggleAll="false" placeholder="انتخاب اقامتگاه" />
            <!-- <Dropdown 
                        @change="getListTransactions(pageIndex)"
                        v-model="PlacesId" 
                        :options="places" 
                        optionLabel="name"
                        optionValue="id"
                        placeholder="انتخاب اقامتگاه"/> -->
          </div>
          <div class="col-12 md:col-3">
            <Dropdown v-model="IsSuccess" :options="transactionStatus" optionLabel="type" optionValue="value" placeholder="وضعیت" />
          </div>
          <div class="col-12 md:col-3">
            <Dropdown v-model="Type" :options="transactionTypes" optionLabel="type" optionValue="code" placeholder="نوع تراکنش" />
          </div>
          <div class="field col-12 md:col-3">
            <span class="p-input-icon-left">
              <i v-if="!FromDate" style="font-size: 1.5rem" class="pi pi-calendar" />
              <i
                v-else
                @click="
                  FromDate = null;
                  getListTransactions(pageIndex);
                "
                style="font-size: 1.5rem"
                class="pi pi-calendar-times cursor-pointer"
              />
              <InputText dir="rtl" v-model="FromDateInput" type="text" id="fromCalendarInputId" placeholder="از تاریخ" />
            </span>
            <custom-date-picker auto-submit v-model="FromDate" :max="currentDate" format="YYYY-MM-DD" display-format="jYYYY/jMM/jDD" custom-input="#fromCalendarInputId" />
          </div>
          <div class="field col-12 md:col-3">
            <span class="p-input-icon-left">
              <i v-if="!ToDate" style="font-size: 1.5rem" class="pi pi-calendar" />
              <i
                v-else
                @click="
                  ToDate = null;
                  getListTransactions(pageIndex);
                "
                style="font-size: 1.5rem"
                class="pi pi-calendar-times cursor-pointer"
              />
              <InputText dir="rtl" v-model="ToDateInput" type="text" id="toCalendarInputId" placeholder="تا تاریخ" />
            </span>
            <custom-date-picker auto-submit v-model="ToDate" :max="currentDate" format="YYYY-MM-DD" display-format="jYYYY/jMM/jDD" custom-input="#toCalendarInputId" />
          </div>
          <div class="field col-12 md:col-2">
            <Button @click="getListTransactions(pageIndex)">اعمال فیلتر</Button>
          </div>
        </div>
        <!-- Table Section Begin -->
        <div v-if="!!transactions.length">
          <DataTable
            :loading="loading.getData"
            ref="dt"
            :value="transactions"
            dataKey="id"
            class="overflow-hidden border-round-2xl shadow-1 mt-5 animate__animated animate__fadeIn"
            responsiveLayout="scroll"
          >
            <template #loading>
              <Loading />
            </template>
            <Column field="title" headerStyle="width:14%; min-width:10rem;">
              <template #header>
                <small class="p-column-title">از</small>
              </template>
              <template #body="slotProps">
                <small>
                  {{ slotProps.data.type === 5 ? "بانک" : slotProps.data.sourceTitle }}
                </small>
              </template>
            </Column>
            <Column field="title" headerStyle="width:14%; min-width:10rem;">
              <template #header>
                <small class="p-column-title">به</small>
              </template>
              <template #body="slotProps">
                <small>
                  {{ slotProps.data.destinationTitle }}
                </small>
              </template>
            </Column>
            <Column field="title" headerStyle="width:14%; min-width:10rem; font-size: 12px;">
              <template #header>
                <small class="p-column-title">مقدار تراکنش (تومان)</small>
              </template>
              <template #body="slotProps">
                <small>
                  {{ slotProps.data.amount.toLocaleString("fa-IR") }}
                </small>
              </template>
            </Column>
            <Column headerStyle="width:14%; min-width:10rem;">
              <template #header>
                <small class="p-column-title">وضعیت</small>
              </template>
              <template #body="slotProps">
                <small :class="[slotProps.data.isSucceed ? 'text-green-400' : 'text-red-400']">
                  <small>
                    {{ slotProps.data.isSucceed ? "موفق" : "نا موفق" }}
                  </small>
                </small>
              </template>
            </Column>
            <Column headerStyle="width:14%; min-width:10rem;">
              <template #header>
                <small class="p-column-title">تاریخ تراکنش</small>
              </template>
              <template #body="slotProps">
                <small>
                  {{ new Date(slotProps.data.createdAt).toLocaleDateString("fa-IR") }}
                </small>
              </template>
            </Column>
            <Column headerStyle="width:14%; min-width:10rem;">
              <template #header>
                <small class="p-column-title">نوع تراکنش</small>
              </template>
              <template #body="slotProps">
                <small>
                  {{ transactionTypes.find((item) => item.code === slotProps.data.type).type }}
                </small>
              </template>
            </Column>
            <Column headerStyle="width:14%; min-width:10rem;">
              <template #header>
                <small class="p-column-title">کد رهگیری</small>
              </template>
              <template #body="slotProps">
                <small>
                  {{ !slotProps.data.bankTransaction ? "ندارد" : slotProps.data.bankTransaction.transactionCode ? slotProps.data.bankTransaction.transactionCode : "ندارد" }}
                </small>
              </template>
            </Column>
          </DataTable>
          <Paginator :rows="pageSize" :totalRecords="totalCount" @page="changePaging($event)"></Paginator>
        </div>
        <div v-else class="w-full text-center my-3">
          <InlineMessage>موردی وجود ندارد</InlineMessage>
        </div>
        <!-- Table Section End -->
      </div>
    </div>
  </div>
</template>

<script>
import { handleQuery } from "@/utils/index";
export default {
  name: "transactions",
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      totalCount: 1,
      pageCount: 1,
      loading: {
        getData: false,
      },
      transactionStatus: [
        { type: "همه", value: null },
        { type: "موفق", value: true },
        { type: "ناموفق", value: false },
      ],
      transactions: [
        // {
        //   "id": 0,
        //   "reserveId": 0,
        //   "sourceTitle": "string",
        //   "destinationTitle": "string",
        //   "amount": 0,
        //   "isSucceed": true,
        //   "createdAt": "2022-10-28T18:24:19.204Z",
        //   "type": 0, ==> // {
        //     Reserve = 0, ذخیره => source user destination eghamatgah
        //     Commision = 1, کمیسیون => source eghamatgah destination super admin
        //     CancelCommision = 2, کمیسیون لغو => source super admin destination eghamatgah
        //     CancelReserve = 3, لغو رزرو => source eghamatgah destination user
        //     Withdrawal = 4, برداشت از حساب =>
        //     Deposit = 5 واریز => source bank destination user
        //   }
        //   "bankTransaction": {
        //     "gateway": "string",
        //     "authority": "string",
        //     "errorMessage": "string",
        //     "transactionCode": "string"
        //   }
        // }
      ],
      currentDate: `${new Date(Date.now()).getFullYear()}-${new Date(Date.now()).getMonth() + 1}-${new Date(Date.now()).getDate() + 1}`,
      transactionTypes: [
        { type: "همه", code: null },
        { type: "ذخیره", code: 0 },
        { type: "کمیسیون", code: 1 },
        { type: "کمیسیون لغو", code: 2 },
        { type: "لغو رزرو", code: 3 },
        { type: "برداشت از حساب", code: 4 },
        { type: "واریز", code: 5 },
      ],
      FromDateInput: "",
      ToDateInput: "",
      IsSuccess: null,
      FromDate: "",
      ToDate: "",
      Type: "",
      ReserveId: null,
      UserId: null,
      PlacesId: null,
      places: [],
      totalItemsCount: [],
    };
  },
  methods: {
    //******* Api methods begin *******//
    async getListTransactions(page = 1) {
      this.loading["getData"] = true;
      let params = {
        IsSuccess: this.IsSuccess,
        PageIndex: page,
        PageSize: this.pageSize,
        Type: this.Type,
        FromDate: this.FromDate,
        ToDate: this.ToDate,
        ReserveId: this.ReserveId,
        SearchUserId: this.UserId,
        PlacesId: !!this.PlacesId?.length ? this.PlacesId : null,
      };
      const { status, data } = await this.axios.get(`transaction`, { params: params, paramsSerializer: handleQuery });
      if (status === 200) {
        this.pageSize = Number(data.pageSize);
        this.pageIndex = data.pageIndex;
        this.totalCount = Number(data.totalCount);
        this.pageCount = +data.pageCount;
        this.transactions = [...data.data];
        setTimeout(() => {
          this.loading["getData"] = false;
        }, 500);
      }
    },
    async getListPlaces(page = 1) {
      const { status, data } = await this.axios({ method: "get", url: `Place/GetAll?TitleQuery=&PageIndex=${page}&PageSize=${this.pageSize}` });
      this.totalItemsCount = data.pageCount;
      this.places.push.apply(this.places, data.data);
      // this.places = [...data.data];
    },
    //******* Api methods end *******//
    changePaging(e) {
      this.getListTransactions(++e.page);
    },
  },
  mounted() {
    this.getListTransactions();
    this.getListPlaces();
  },
};
</script>
